<template>
  <v-dialog
    v-model="dialog"
    :width="$vuetify.breakpoint.lgAndUp ? 'auto' : '100%'"
    :fullscreen="$vuetify.breakpoint.xsOnly"
  >
    <v-form ref="form" v-model="valid" :readonly="isReadOnly" @submit.prevent="submit()">
      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>
        <v-card-text>
          <alert-message></alert-message>
          <v-row>
            <v-col>
              <v-card>
                <v-card-text>
                  <v-tabs v-model="tab">
                    <v-tab> General </v-tab>
                    <v-tab> Address </v-tab>
                    <v-tab> TimeClocks </v-tab>
                    <v-tab> Materials </v-tab>
                    <v-tab v-if="formTitle !== 'Add Job'"> Files </v-tab>
                  </v-tabs>

                  <v-tabs-items v-model="tab">
                    <!-- GENERAL -->
                    <v-tab-item>
                      <v-card>
                        <v-card-text>
                          <v-row>
                            <v-col
                              class="d-flex"
                              cols="12"
                              sm="6"
                              md="6"
                              lg="6"
                              xl="6"

                            >
                              <div class="mr-2">
                                <color-select v-model="form.task.color" />
                              </div>
                              <v-text-field
                                label="Job Code *"
                                v-model="form.task.code"
                                :hide-details="true"
                                :error-messages="[].concat(fieldErrors('form.task.code'))"
                                @blur="$v.form.task.code.$touch()"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              :sm="form.task.type == 'Custom' ? 3 : 6"
                            >
                              <v-select
                                label="Label *"
                                v-model="form.task.type"
                                :items="typeList"
                                :hide-details="true"
                                :error-messages="[].concat(fieldErrors('form.task.type'))"
                                @blur="$v.form.task.type.$touch()"
                              />
                            </v-col>
                            <v-col
                              v-show="form.task.type == 'Custom'"
                              cols="12"
                              sm="3"
                            >
                              <v-text-field
                                label="Custom Label"
                                v-model="form.task.typeCustom"
                                :hide-details="true"
                              />
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12">
                              <v-text-field
                                v-model="form.task.name"
                                label="Job Name *"
                                :solo="false"
                                :readonly="isReadOnly"
                                :error-messages="
                                  [].concat(
                                    fieldErrors('form.task.name'),
                                    serverSideErrors('Name')
                                  )
                                "
                                @blur="$v.form.task.name.$touch()"
                              />
                            </v-col>
                          </v-row>

                          <v-row>
                            <v-col cols="12">
                              <v-textarea
                                v-model="form.task.description"
                                label="Description"
                                :error-messages="
                                  [].concat(
                                    fieldErrors('form.task.description'),
                                    serverSideErrors('Description')
                                  )
                                "
                                @blur="$v.form.task.description.$touch()"
                                rows="3"
                                auto-grow
                              ></v-textarea>
                            </v-col>

                            <v-col cols="12">
                              <client-select
                                :error-messages="
                                  [].concat(
                                    fieldErrors('form.task.clientId'),
                                    serverSideErrors('ClientId')
                                  )
                                "
                                v-model="form.task.clientId"
                                label="Select Client *"
                                @blur="$v.form.task.clientId.$touch()"
                                :readonly="isReadOnly"
                              />
                            </v-col>
                            <v-col cols="12">
                              <user-select
                                v-model="form.userIds"
                                label="Assign To"
                                :error-messages="
                                  [].concat(
                                    fieldErrors('form.userIds'),
                                    serverSideErrors('UserIds')
                                  )
                                "
                                @blur="$v.form.userIds.$touch()"
                                :multiple="true"
                                :readonly="isReadOnly"
                              />
                            </v-col>
                          </v-row>

                          <v-row>
                            <v-col cols="12" sm="6" v-show="item.id">
                              <TaskStatusSelect
                                v-model="form.task.status"
                                label="Select Status"
                                :error-messages="
                                  [].concat(
                                    fieldErrors('form.task.status'),
                                    serverSideErrors('Status')
                                  )
                                "
                                @blur="$v.form.task.status.$touch()"
                                :readonly="isReadOnly"
                              />
                            </v-col>
                            <v-col
                              cols="12" sm="6"
                              v-show="form.task.status == 'completed'"
                            >
                              <date-picker
                                v-model="form.task.dateCompleted"
                                label="Completed at"
                                @blur="$v.form.task.date.$touch()"
                                :hideDetails="true"
                                :dense="true"
                              />
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </v-card>
                    </v-tab-item>

                    <!-- ADDRESS -->
                    <v-tab-item>
                      <v-card>
                        <v-card-text>
                          <v-row>
                            <v-col cols="12">
                              <v-text-field
                                label="Street"
                                v-model="form.task.addressStreet"
                                :hide-details="true"
                              />
                            </v-col>
                            <v-col cols="12" sm="4">
                              <v-text-field
                                label="City"
                                v-model="form.task.addressCity"
                                :hide-details="true"
                              />
                            </v-col>
                            <v-col cols="12" sm="4">
                              <v-text-field
                                label="State"
                                v-model="form.task.addressState"
                                :hide-details="true"
                              />
                            </v-col>
                            <v-col cols="12" sm="4">
                              <v-text-field
                                label="Zip Code"
                                v-model="form.task.addressZipCode"
                                :hide-details="true"
                              />
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </v-card>
                    </v-tab-item>

                    <!-- TIMECLOCKS -->
                    <v-tab-item>
                      <div v-if="isEdit">
                        <TimeClockEntry :item="item" />
                      </div>
                      <div v-else class="p-5">Data not available</div>
                    </v-tab-item>

                    <!-- MATERIALS -->
                    <v-tab-item>
                      <v-card>
                        <v-card-text>
                          <v-row>
                            <v-col cols="12">
                              <v-btn x-small @click="addChangeOrder()" :disabled="isReadOnly">
                                <v-icon>mdi-plus</v-icon>
                                Change Order</v-btn
                              >
                            </v-col>
                            <v-col cols="12" v-show="changeOrders.length > 0">
                              <v-sheet elevation="6">
                                <v-tabs
                                  next-icon="mdi-arrow-right-bold-box-outline"
                                  prev-icon="mdi-arrow-left-bold-box-outline"
                                  show-arrows
                                  v-model="tabs"
                                >
                                  <v-tabs-slider></v-tabs-slider>
                                  <v-tab
                                    v-for="(
                                      changeOrder, changeOrderIdx
                                    ) in changeOrderReversed"
                                    :key="`${changeOrderIdx}_changeOrders_tab`"
                                    :href="'#tab-' + changeOrderIdx"
                                  >
                                    {{ changeOrder.changeOrderName || '!!' }}
                                  </v-tab>
                                </v-tabs>

                                <v-tabs-items v-model="tabs">
                                  <v-tab-item
                                    v-for="(
                                      changeOrder, changeOrderIdx
                                    ) in changeOrderReversed"
                                    :key="`${changeOrderIdx}_changeOrders_content`"
                                    :value="'tab-' + changeOrderIdx"
                                  >
                                    <v-card>
                                      <v-card-title style="align-items: self-end">
                                        <v-text-field
                                          placeholder="Change Order *"
                                          v-model="changeOrder.changeOrderName"
                                          :hide-details="true"
                                          :error-messages="[].concat(
                                            fieldErrors(
                                              [
                                                `changeOrderReversed`,
                                                `.$each[${changeOrderIdx}]`,
                                                `.changeOrderName`                                                
                                              ].join(''),
                                              [
                                                `changeOrderReversed`,
                                                `.$each`,
                                                `.changeOrderName`,
                                              ].join(''),
                                            )
                                          )
                                            "
                                          @blur="
                                            $v
                                              .changeOrderReversed
                                              .$each[changeOrderIdx]
                                              .changeOrderName
                                              .$touch()
                                            "
                                        />
                                        
                                        <v-spacer />
                                        <v-btn
                                          x-small
                                          class="ma-1"
                                          color="error"
                                          :disabled="isReadOnly"
                                          @click="
                                            removeChangeOrder(changeOrderIdx)
                                          "
                                        >
                                          <v-icon>mdi-delete</v-icon>
                                          Delete
                                        </v-btn>
                                        <v-btn
                                          x-small
                                          :disabled="isReadOnly"
                                          @click="addMaterial(changeOrderIdx)"
                                          class="ma-1"
                                          ><v-icon>mdi-plus</v-icon>
                                          Material</v-btn
                                        >
                                      </v-card-title>
                                      <v-card-text>
                                        <v-card
                                          class="mt-2"
                                          v-for="(
                                            material, materialIdx
                                          ) in changeOrder.materials"
                                          :key="`${changeOrderIdx}_${materialIdx}_materials`"
                                        >
                                          <v-card-text>
                                            <v-row>
                                              <v-col
                                                cols="12"
                                                xl="4"
                                                lg="6"
                                                md="4"
                                                sm="12"
                                              >
                                                <v-text-field
                                                  label="Material *"
                                                  v-model="
                                                    material.materialName
                                                  "
                                                  :hide-details="true"
                                                  :error-messages="
                                                    [].concat(
                                                      fieldErrors(
                                                        [
                                                          `changeOrderReversed`,
                                                          `.$each[${changeOrderIdx}]`,
                                                          `.materials`,
                                                          `.$each[${materialIdx}]`,
                                                          `.materialName`
                                                        ].join(''),
                                                        [
                                                          `changeOrderReversed`,
                                                          `.$each`,
                                                          `.materials`,
                                                          `.$each`,
                                                          `.materialName`
                                                        ].join(''),
                                                      )
                                                    )
                                                  "
                                                  @blur="
                                                    $v
                                                    .changeOrderReversed
                                                    .$each[changeOrderIdx]
                                                    .materials
                                                    .$each[materialIdx]
                                                    .materialName
                                                    .$touch()
                                                  "
                                                >
                                                  <v-icon
                                                    slot="prepend"
                                                    color="error"
                                                    @click="
                                                      removeMaterial(
                                                        changeOrderIdx,
                                                        materialIdx
                                                      )
                                                    "
                                                  >
                                                    mdi-delete
                                                  </v-icon>
                                                </v-text-field>
                                              </v-col>
                                              <v-col
                                                cols="12"
                                                xl="1"
                                                lg="2"
                                                md="3"
                                                sm="6"
                                              >
                                                <v-text-field
                                                  v-model="material.quantity"
                                                  label="Amount of Footage *"
                                                  :hide-details="true"
                                                  type="number"
                                                  :min="0"
                                                  :error-messages="
                                                    [].concat(
                                                      fieldErrors(
                                                        [
                                                          `changeOrderReversed`,
                                                          `.$each[${changeOrderIdx}]`,
                                                          `.materials`,
                                                          `.$each[${materialIdx}]`,
                                                          `.quantity`
                                                        ].join(''),
                                                        [
                                                          `changeOrderReversed`,
                                                          `.$each`,
                                                          `.materials`,
                                                          `.$each`,
                                                          `.quantity`
                                                        ].join(''),
                                                      )
                                                    )
                                                  "
                                                  @blur="
                                                    $v
                                                    .changeOrderReversed
                                                    .$each[changeOrderIdx]
                                                    .materials
                                                    .$each[materialIdx]
                                                    .quantity
                                                    .$touch()
                                                  "
                                                >
                                                </v-text-field>
                                              </v-col>
                                              <v-col
                                                cols="12"
                                                xl="1"
                                                lg="2"
                                                md="2"
                                                sm="6"
                                              >
                                                <v-select
                                                  v-model="material.unit"
                                                  :items="['ft²', 'Lineal ft']"
                                                  label="Footage Unit *"
                                                  :hide-details="true"
                                                  :error-messages="
                                                    [].concat(
                                                      fieldErrors(
                                                        [
                                                          `changeOrderReversed`,
                                                          `.$each[${changeOrderIdx}]`,
                                                          `.materials`,
                                                          `.$each[${materialIdx}]`,
                                                          `.unit`
                                                        ].join(''),
                                                        [
                                                          `changeOrderReversed`,
                                                          `.$each`,
                                                          `.materials`,
                                                          `.$each`,
                                                          `.unit`
                                                        ].join(''),
                                                      )
                                                    )
                                                  "
                                                  @blur="
                                                    $v
                                                    .changeOrderReversed
                                                    .$each[changeOrderIdx]
                                                    .materials
                                                    .$each[materialIdx]
                                                    .unit
                                                    .$touch()
                                                  "
                                                ></v-select>
                                              </v-col>
                                              <v-col
                                                cols="12"
                                                xl="1"
                                                lg="2"
                                                md="3"
                                                sm="6"
                                              >
                                                <v-text-field
                                                  label="Amount of Material *"
                                                  v-model="
                                                    material.quantityPerCase
                                                  "
                                                  type="number"
                                                  :hide-details="true"
                                                  :min="0"
                                                  :error-messages="
                                                    [].concat(
                                                      fieldErrors(
                                                        [
                                                          `changeOrderReversed`,
                                                          `.$each[${changeOrderIdx}]`,
                                                          `.materials`,
                                                          `.$each[${materialIdx}]`,
                                                          `.quantityPerCase`
                                                        ].join(''),
                                                        [
                                                          `changeOrderReversed`,
                                                          `.$each`,
                                                          `.materials`,
                                                          `.$each`,
                                                          `.quantityPerCase`
                                                        ].join(''),
                                                      )
                                                    )
                                                  "
                                                  @blur="
                                                    $v
                                                    .changeOrderReversed
                                                    .$each[changeOrderIdx]
                                                    .materials
                                                    .$each[materialIdx]
                                                    .quantityPerCase
                                                    .$touch()
                                                  "
                                                >
                                                </v-text-field>
                                              </v-col>
                                              <v-col
                                                cols="12"
                                                xl="1"
                                                lg="3"
                                                md="3"
                                                sm="6"
                                              >
                                                <v-select
                                                  v-model="material.case"
                                                  :items="caseList"
                                                  label="Material Unit *"
                                                  :hide-details="true"
                                                ></v-select>
                                              </v-col>
                                              <v-col
                                                cols="12"
                                                xl="2"
                                                lg="3"
                                                md="4"
                                                sm="6"
                                                v-if="material.case === 'Custom'"
                                              >
                                                <v-text-field
                                                  label="Custom Material Unit *"
                                                  v-model="material.caseCustom"
                                                  :hide-details="true"
                                                />
                                              </v-col>

                                              <v-col
                                                cols="12"
                                                xl="1"
                                                lg="2"
                                                md="2"
                                                sm="3"
                                              >
                                                <v-text-field
                                                  v-model="material.hours"
                                                  label="Man Hours *"
                                                  type="number"
                                                  :hide-details="true"
                                                  :min="0"
                                                  :error-messages="
                                                    [].concat(
                                                      fieldErrors(
                                                        [
                                                          `changeOrderReversed`,
                                                          `.$each[${changeOrderIdx}]`,
                                                          `.materials`,
                                                          `.$each[${materialIdx}]`,
                                                          `.hours`
                                                        ].join(''),
                                                        [
                                                          `changeOrderReversed`,
                                                          `.$each`,
                                                          `.materials`,
                                                          `.$each`,
                                                          `.hours`
                                                        ].join(''),
                                                      )
                                                    )
                                                  "
                                                  @blur="
                                                    $v
                                                    .changeOrderReversed
                                                    .$each[changeOrderIdx]
                                                    .materials
                                                    .$each[materialIdx]
                                                    .hours
                                                    .$touch()
                                                  "
                                                />
                                              </v-col>

                                              <v-col
                                                cols="12"
                                                xl="1"
                                                lg="2"
                                                md="2"
                                                sm="3"
                                              >
                                                <v-text-field
                                                  v-model="material.minutes"
                                                  label="Minutes *"
                                                  type="number"
                                                  :hide-details="true"
                                                  :min="0"
                                                  :max="59"
                                                  :error-messages="
                                                    [].concat(
                                                      fieldErrors(
                                                        [
                                                          `changeOrderReversed`,
                                                          `.$each[${changeOrderIdx}]`,
                                                          `.materials`,
                                                          `.$each[${materialIdx}]`,
                                                          `.minutes`
                                                        ].join(''),
                                                        [
                                                          `changeOrderReversed`,
                                                          `.$each`,
                                                          `.materials`,
                                                          `.$each`,
                                                          `.minutes`
                                                        ].join(''),
                                                      )
                                                    )
                                                  "
                                                  @blur="
                                                    $v
                                                    .changeOrderReversed
                                                    .$each[changeOrderIdx]
                                                    .materials
                                                    .$each[materialIdx]
                                                    .minutes
                                                    .$touch()
                                                  "
                                                />
                                              </v-col>
                                            </v-row>
                                          </v-card-text>
                                        </v-card>
                                      </v-card-text>
                                    </v-card>
                                  </v-tab-item>
                                </v-tabs-items>
                              </v-sheet>
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </v-card>
                    </v-tab-item>

                    <!-- FILES -->
                    <v-tab-item v-if="formTitle !== 'Add Job'">
                      <div v-if="isEdit">
                        <FormFiles :item="item" :show="tab == 5" />
                      </div>
                      <div v-else class="p-5">Data not available</div>
                    </v-tab-item>
                  </v-tabs-items>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="darken-1" @click="dialog = false">
            {{ this.isReadOnly ? 'Close' : 'Cancel'}}
          </v-btn>
          <v-btn
            :disabled="$v.$invalid"
            type="submit"
            color="info"
            :loading="loading"
            v-if="!isReadOnly"
          >
            {{ isEdit ? "Save" : "Add" }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
    <AttachedFileListDialog
      :show="showAttachFile"
      :item="item"
      object="task"
      @onClosed="clearAttachFile()"
      @onSucceded="refresh()"
    />
  </v-dialog>
</template>

<script>
import UTIL from "src/helpers/utility";
import { mapActions, mapGetters, mapState } from "vuex";
import AlertMessage from "src/components/AlertMessage";
import { required } from "vuelidate/lib/validators";
import validationMixin from "@/mixins/validationMixin";
import ClientSelect from "components/ClientSelect.vue";
import DatePicker from "components/DatePicker.vue";
import UserSelect from "src/components/UserSelect";
import formatterMixin from "@/mixins/formatterMixin";
import TaskStatusSelect from "components/TaskStatusSelect";
import ColorSelect from "components/ColorSelect";
import AttachedFileListDialog from "components/FilesAttachment/AttachedFileListDialog";
import TimeClockEntry from "./_TimeClockEntry";
import FormFiles from "./__Files";

const defaultInputs = {
  task: {
    id: "",
    code: "",
    name: "",
    status: "open",
    type: "Standard",
    date: new Date(),
    endDate: new Date(),
    addressStreet: "",
    addressCity: "",
    addressState: "",
    addressZipCode: "",
    time: undefined,
    endTime: undefined,
    description: "",
    clientId: "",
    payRate: 0,
    tags: [],
    color: "#ad1457",
    isTimeClockRunning: false,
    isInvoiced: false,
    isCompleted: false,
    dateCreated: null,
    lastUpdated: null,
    typeCustom: "",
  },
  userIds: [],
};

export default {
  components: {
    AlertMessage,
    ClientSelect,
    DatePicker,
    UserSelect,
    FormFiles,
    TaskStatusSelect,
    ColorSelect,
    AttachedFileListDialog,
    TimeClockEntry,
  },
  props: {
    clientId: Number,
    item: Object,
    show: [Boolean, String],
    title: String,
  },
  mixins: [validationMixin, formatterMixin],
  validations: {
    form: {
      userIds: {},
      task: {
        name: { required },
        status: {},
        code: { required },
        type: { required },
        date: {},
        endDate: {},
        time: {},
        endTime: {},
        clientId: { required },
        description: {},
        payRate: {},
        tags: {},
        dateCompleted: {},
      },
    },
    changeOrderReversed: {
      $each: {
        changeOrderName: { required },
        materials: {
          $each: {
            taskId: {},
            changeOrderId: {},
            materialName: { required },
            quantity: { required },
            quantityPerCase: { required },
            case: { required },
            caseCustom: {},
            unit: { required },
            hours: { required },
            minutes: { required },
          },
        },
      },
    },
  },
  validationMessages: {
    form: {
      userIds: { required: "Required" },
      task: {
        dateCompleted: {},
        name: { required: "Required" },
        status: { required: "Required" },
        code: { required: "Required" },
        type: { required: "Required" },
        date: { required: "Required" },
        time: { required: "Required" },
        endTime: { required: "Required" },
        description: { required: "Required" },
        clientId: { required: "Required" },
        payRate: {},
        tags: {},
      },
    },
    changeOrderReversed: {
      $each: {
        changeOrderName: { required: "Required" },
        materials: {
          $each: {
            taskId: {},
            changeOrderId: {},
            materialName: { required: "Required" },
            quantity: { required: "Required" },
            quantityPerCase: { required: "Required" },
            case: { required: "Required" },
            caseCustom: {},
            unit: { required: "Required" },
            hours: { required: "Required" },
            minutes: { required: "Required" },
          },
        },
      },
    },
  },

  data() {
    return {
      tab: null,
      tabs: null,
      showDialog: this.show,
      isReadOnly: true,
      src: null,
      form: {
        ...defaultInputs,
        task: {
          ...defaultInputs.task,
          clientId: this.clientId,
        },
        materials: [],
        changeOrders: [],
      },

      typeOptions: [
        { value: "remote", text: "Remote Support" },
        { value: "onsite", text: "Onsite Support" },
      ],

      statusOptions: [
        { value: "open", text: "Open" },
        { value: "closed", text: "Closed" },
        { value: "complete", text: "Completed" },
      ],

      dialog: false,
      valid: false,
      loading: false,
      showAttachFile: false,
      materials: [],
      changeOrders: [],
      typeList: ["Custom", "PLA", "Prevailing Wage", "Standard", "Union"],
      caseList: ["Case", "Custom", "Gallon", "Roll", "Sausage", "Tube"],
    };
  },

  watch: {
    show(n, o) {
      if (n && !o) {
        this.dialog = true;
        this.tab = 0;
      }
    },

    src(n) {
      if (n) {
        this.form.task.name = typeof n == "string" ? n : n.name;
        if (n && n.name) {
          this.form.task.type = n.type;
        }
      }
    },

    dialog(n, o) {
      if (!n && o) {
        this.onDialogClose();
      } else {
        this.onDialogOpen();
      }
    },

    item(newTask, oldTask) {
      if (newTask && JSON.stringify(newTask) !== JSON.stringify(oldTask)) {
        let userIds = [];
        if (newTask.taskUsers) {
          userIds = newTask.taskUsers.map((user) => user.userId);
        }

        let jobMaterials = newTask.jobMaterials || [];
        jobMaterials = jobMaterials.map((jobMaterial) => {
          const caseFinal = !this.caseList.includes(jobMaterial.case)
            ? "Custom"
            : jobMaterial.case;
          const caseFinalCustom = caseFinal === "Custom" ? jobMaterial.case : "";

          const seconds = Number(jobMaterial.seconds) || 0;
          const hours = Math.floor(seconds / 3600);
          const minutes = Math.floor(seconds % 3600 / 60);

          return {
            ...jobMaterial,
            case: caseFinal,
            caseCustom: caseFinalCustom,
            hours: hours,
            minutes: minutes,
          };
        });

        let typeFinal = !this.typeList.includes(newTask.type)
          ? "Custom"
          : newTask.type;
        let typeFinalCustom = typeFinal === "Custom" ? newTask.type : "";

        this.form = {
          task: {
            ...newTask,
            type: typeFinal,
            typeCustom: typeFinalCustom,
            tags: newTask.categories ? newTask.categories.map((c) => c.id) : [],
            // date: this.momentLocal(newTask.date).format("YYYY-MM-DD"),
            // time: this.formatDatetime(newTask.date).split(" ")[1],
            // endDate: this.momentLocal(newTask.date).format("YYYY-MM-DD"),
            // endTime: this.formatDatetime(newTask.endDate).split(" ")[1],
            // time: this.momentLocal(newTask.date).format('HH:mm'),
          },
          materials: jobMaterials,
          userIds,
        };
        this.src = newTask.name;

        // parse changeOrder here
        let changeOrders = [
          ...new Set(jobMaterials.map((obj) => obj.changeOrderId)),
        ];
        let tempOrders = changeOrders.map((changeOrderIdx) => {
          const defaultName = changeOrderIdx == 1 ? "Original" : `CO #${changeOrderIdx - 1}`;
          return {
            id: changeOrderIdx,
            changeOrderName: jobMaterials.find((m) => m.changeOrderId == changeOrderIdx)
              ?.changeOrderName || defaultName,
            materials: jobMaterials.filter(
              (m) => m.changeOrderId == changeOrderIdx
            ),
          };
        });

        this.changeOrders = tempOrders;

        // sort by change order id, to keep original quote and additional quote tab position
        this.changeOrders.sort(function (a, b) {
          return a.id - b.id;
        });
      } else {
        this.form = {
          ...defaultInputs,
          task: {
            ...defaultInputs.task,
            clientId: this.clientId,
            // date: this.momentLocal().format("YYYY-MM-DD"),
            // time: this.momentLocal().format("HH:mm"),
            // endDate: this.momentLocal().format("YYYY-MM-DD"),
            // endTime: this.momentLocal().add(1, "hour").format("HH:mm"),
          },
          userIds: [this.user.id],
          materials: [],
        };
        // set default change order here
        this.changeOrders = [];
      }
    },
  },

  computed: {
    ...mapGetters("account", ["hasAccess"]),
    ...mapState({
      account: (state) => state.account,
      user: (state) => state.account.data.user,
      task: (state) => state.task,
      alert: (state) => state.alert,
    }),
    formTitle() {
      let prefix = "Add Job"
      if(this.isEdit) prefix = "Edit Job"
      if(this.isReadOnly) prefix = "View Job"
      let suffix = ""
      if(this.item.code || this.item.name) {
        suffix += ":"
        suffix += this.item.code ? ` [${this.item.code}]` : ""
        suffix += this.item.name ? " " + this.item.name : ""
      }
      return prefix + suffix;
    },
    isEdit() {
      return UTIL.gv(this.item, "id", "") ? true : false;
    },
    taskId() {
      return UTIL.gv(this.item, "id", "");
    },
    changeOrderReversed() {
      return [...this.changeOrders];
    },
  },

  methods: {
    ...mapActions("task", ["create", "update"]),
    ...mapActions({
      createTimeClock: "timeclock/createFromTask",
      createJobFolder: "storageFolder/createJobFolder",
    }),

    viewOrAddFile() {
      this.showAttachFile = true;
    },

    clearAttachFile() {
      this.showAttachFile = false;
    },

    refresh() {},

    addMaterial(changeOrderIdx) {
      let newMaterial = {
        taskId: this.item ? this.item.id : null,
        changeOrderId: changeOrderIdx,
        materialName: "",
        quantity: 0,
        quantityPerCase: 0,
        case: "Case",
        caseCustom: "",
        unit: "",
        hours: 0,
        minutes: 0,
      };

      this.changeOrders[changeOrderIdx].materials.push(newMaterial);
    },

    addChangeOrder() {
      let changeOrderIdx = this.changeOrders.length;
      let changeOrderName = changeOrderIdx === 0
        ? "Original"
        : `CO #${changeOrderIdx}`;

      let firstOrderTab = {
        id: changeOrderIdx + 1,
        changeOrderName,
        materials: [],
      };
      this.changeOrders.push(firstOrderTab);
      this.addMaterial(changeOrderIdx);
    },

    removeMaterial(changeOrderIdx, materialIdx) {
      this.changeOrders[changeOrderIdx].materials.splice(materialIdx, 1);
    },

    removeChangeOrder(changeOrderIdx) {
      if (confirm("Are you sure will delete this change order?")) {
        this.changeOrders.splice(changeOrderIdx, 1);
      }
    },

    initForm() {
      if (this.clientId) {
        let categories = this.optional(this.item, "categories", []) || [];
        this.form = {
          ...this.form,
          task: {
            ...this.form.task,
            clientId: this.clientId,
            time: "00:00:00",
            tags: categories.map((category) => category.id),
          },
        };
      }
    },

    serverSideErrors(field) {
      return UTIL.gv(this.task.errors, field, []);
    },
    onDialogClose() {
      if (this.isEdit) {
        //
      } else {
        //
      }
      this.$emit("onClosed");
    },

    onDialogOpen() {
      this.$store.dispatch("alert/clear");
      this.initForm();
      this.isReadOnly = (this.isEdit && !this.hasAccess('task.edit')) ||
        (!this.isEdit && !this.hasAccess('task.add'));
    },

    save() {},
    addNew() {
      this.dialog = true;
      this.form = {
        ...defaultInputs,
      };
    },
    completed() {
      this.$emit("onSucceded");
    },
    async submit() {
      this.loading = true;
      if (!this.valid) {
        this.$store.dispatch("snackbar/error", "Form invalid");
        return false;
      }

      let materials = [];
      for (const changeOrderIdx in this.changeOrders) {
        let changeOrder = this.changeOrders[changeOrderIdx];
        for (const materialIdx in changeOrder.materials) {
          let material = changeOrder.materials[materialIdx];
          delete material.id;
          let totalHoursInSeconds = parseInt(material.hours) * 3600;
          let totalMinutesInSeconds = parseInt(material.minutes) * 60;

          let caseFinal = material.case == "Custom"
            ? material.caseCustom
            : material.case;

          materials.push({
            ...material,
            case: caseFinal,
            changeOrderId: changeOrder.id,
            changeOrderName: changeOrder.changeOrderName,
            seconds: totalHoursInSeconds + totalMinutesInSeconds,
          });
        }
      }

      let typeFinal =
        this.form.task.type == "Custom"
          ? this.form.task.typeCustom
          : this.form.task.type;

      let payload = {
        ...this.form,
        task: {
          ...this.form.task,
          // date: this.momentLocal(
          //   this.form.task.date + ` ` + this.form.task.time
          // ).format('YYYY-MM-DD h:i'),
          // endDate: this.momentLocal(
          //   this.form.task.endDate + ` ` + this.form.task.endTime
          // ).format('YYYY-MM-DD h:i'),
          // isScheduled: false,
          type: typeFinal,
        },
        tags: this.form.task.tags,
        materials: materials,
      };
      delete payload.task.timeClockEntries;

      if (
        payload.task.status === "open" ||
        payload.task.status === "inprogress" ||
        payload.task.status === "available" ||
        !payload.task.status
      ) {
        payload.task.isCompleted = false;
        payload.task.dateCompleted = null;
        if (!payload.task.invoiceId) {
          payload.task.isInvoiced = false;
        }
      } else if (payload.task.status === "completed") {
        payload.task.isCompleted = true;
      } else if (payload.task.status === "invoiced") {
        payload.task.isCompleted = true;
        if (payload.task.invoiceId) {
          payload.task.isInvoiced = true;
        }
      } else if (payload.task.status === "canceled") {
        payload.task.isCompleted = false;
        payload.task.dateCompleted = null;
        if (!payload.task.invoiceId) {
          payload.task.isInvoiced = false;
        }
      }

      

      if (this.isEdit) {
        payload.task.taskFolderId = payload.task.folderId;
        await this.update({
          id: this.taskId,
          jobCodeValidation: true,
          jobFolderModification: true,
          ...payload,
        });
      } else {
        delete payload.task.id;

        await this.create({
          jobCodeValidation: true,
          jobFolderModification: true,
          ...payload,
        });
        if (!this.task.status.error) {
          // await this.createJobFolder(payload.task.code);
          // await this.createTimeClock({
          //   id: this.task.single.id,
          //   ...payload,
          // });
        }
      }

      if (!this.task.status.error) {
        this.dialog = false;
        this.completed();
      }
      this.loading = false;
    },
  },
};
</script>